import globals from "../../globals";
import { _sendWithAxios, _sendWithAxiosBlob } from "../api";

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const uploadImagemOportunidade = async (file) => {
  const data = new FormData();
  data.append("file", file);
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Upload/upload/produto-opoturunidade`,
    "POST",
    data
  );
};

export const uploadImagensOportunidade = async (files) => {
  const data = new FormData();
  for (let i = 0; i < files.length; i++) {
    data.append(files[i].name, files[i]);
  }
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Upload/upload-files/produto-opoturunidade`,
    "POST",
    data
  );
};

export const cadastrarOportunidade = async (values) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/cadastrar-oportunidade-seller`,
    "POST",
    values
  );
};

export const cadastrarProduto = async (data) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/adicionar-produto-oportunidade`,
    "POST",
    data
  );
};
export const excluirProduto = async (data) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/excluir-produto-oportunidade-seller`,
    "POST",
    data
  );
};

export const editarOportunidade = async (data) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/editar-oportunidade-seller`,
    "PUT",
    data
  );
};

export const disponibilizarOportunidade = async (data) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/disponilizar-oportunidade-seller`,
    "PUT",
    data
  );
};

export const duplicarOportunidade = async (idOportunidade) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/duplicar-oportunidade/${idOportunidade}`,
    "GET"
  );
};
export const listaProdutoPdf = async (idOportunidade) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/lista-produtos-para-pdf/${idOportunidade}`,
    "GET"
  );
};
export const listaProdutoAtivo = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/listar-produto-ativo/${id}`,
    "GET"
  );
};
export const listarTipoOportunidade = async (idOportunidade) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/tipo`,
    "GET"
  );
};
export const gerarPedidoEmPdf = async (idOportunidade) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/lista-produtos-para-pdf/${idOportunidade}`,
    "GET"
  );
};

export const detalheOportunidade = async (idOportunidade) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/detalhe-oportunidade-seller/${idOportunidade}`,
    "GET"
  );
};

export const detalheResumoOportunidade = async (idOportunidade) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/detalhe-resumooportunidade-seller/${idOportunidade}`,
    "GET"
  );
};

export const listarOportunidades = async (filtro, pagina) => {
  try {
    const response = await _sendWithAxios(
      `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/${pagina}/10`,
      "GET",
      { filtro: filtro }
    );
    return response;
  } catch (error) {
    console.error("Erro ao listar produtos:", error);
    throw error;
  }
};

export const listarOportunidadesPorFiltro = async (filtro, pagina) => {
  try {
    const response = await _sendWithAxios(
      `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/${pagina}/10`,
      "POST",
      { filtro: filtro }
    );
    return response;
  } catch (error) {
    console.error("Erro ao listar produtos:", error);
    throw error;
  }
};

export const listarOportunidadesSeller = async (idEmpresa, pagina) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/${idEmpresa}/${pagina}/10`,
    "GET"
  );
};

export const listarOportunidadesPorFiltroSeller = async (
  idEmpresa,
  filtro,
  pagina
) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/${idEmpresa}/${filtro}/${pagina}/10`,
    "GET"
  );
};

export const listarSellersOportunidade = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/listar-sellers`,
    "GET"
  );
};

export const listarVendedoresOportunidade = async (idEmpresa) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/listar-vendedores/${idEmpresa}`,
    "GET"
  );
};

export const listarCdsOportunidadeSeller = async (idEmpresa) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/listar-cds-seller/${idEmpresa}`,
    "GET"
  );
};

export const listarCdsResumoOportunidadeSeller = async (idEmpresa) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/resumooportunidade-listar-cds-seller/${idEmpresa}`,
    "GET"
  );
};

export const buscarProdutoOportunidade = async (idEmpresa, codigo) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/buscar-produto/${idEmpresa}/${codigo}`,
    "GET"
  );
};

export const ResumoOportunidadebuscarProdutoOportunidade = async (
  idEmpresa,
  codigo
) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/resumooportunidade-buscar-produto/${idEmpresa}/${codigo}`,
    "GET"
  );
};

export const buscarCategorias = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/buscar-todascategorias`,
    "GET"
  );
};

export const buscarStatus = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/buscar-todosstatus`,
    "GET"
  );
};
export const buscarStatusOferta = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/status-oferta`,
    "GET"
  );
};
export const motivoDaOferta = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/motivo-oferta`,
    "GET"
  );
};

export const proximaOportunidade = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/oportunidades/proxima-oportunidade`,
    "GET"
  );
};

export const gerarExelOportunidades = async () => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/gerar-exel-oportunidades`,
    "GET"
  );
};

export const gerarExelOportunidadesSeller = async (idEmpresa) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/gerar-exel-oportunidades/${idEmpresa}`,
    "GET"
  );
};
export const gerarConciliacao = async (idEmpresa) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/relatorio-conciliacao/${idEmpresa}`,
    "GET"
  );
};

export const gerarExelModeloImportacao = async () => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/modelo-base-importacao/`,
    "GET"
  );
};

export const importacaoOportunidades = async (
  emailUsuario,
  documento,
  somenteUmaOportunidade,
) => {
  const data = new FormData();
  data.append("file", documento);
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/importacao-oportunidades/${emailUsuario}`,
    "POST",
    data,
    { SomenteUmaOportunidade: false }
  );

};

export const importacaoOportunidadesValidar = async (
  emailUsuario,
  documento
) => {
  const data = new FormData();
  data.append("file", documento);
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/importacao-oportunidades_Validar/${emailUsuario}`,
    "POST",
    data
  );
};

export const listarLogOportunidades = async (page) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/logs-oportunidade/${page}/10`,
    "GET"
  );
};

export const exportacaoResultadoLog = async (tipoResultadoLog, idLog) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}OportunidadeSeller/exportacao-log-oportunidade/${tipoResultadoLog}/${idLog}`,
    "GET"
  );
};
